import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  setPickupDate,
  setPickupTime,
  setCustomTime,
  setUrgencyLevel,
  setShipmentId,
  setpo_number,
  setToTime,
} from "../../redux/shipmentSlice";
import { toast } from "react-toastify";
import { GoogleMap, Marker, useLoadScript, Polyline } from "@react-google-maps/api";
import APIs from "../../APIs";
import { GOOGLE_MAP_KEY } from "../../Utils/Utils";
const mapContainerStyle = {
  width: "100%",
  height: "400px",
  borderRadius: "15px",
};

const Step4 = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  //const user = useSelector((state) => state.auth.userData);
  const pickupAddress = useSelector((state) => state.address.pickupAddress);
  const dropoffAddress = useSelector((state) => state.address.dropoffAddress);
  const { categoryId, items = [], pickupDate, pickupTime, customTime, urgencyLevel, po_number, toTime } =
    useSelector((state) => state.shipment);
  const shipmentId = useSelector((state) => state.shipment.shipmentId);

  const [errors, setErrors] = useState({});
  const { isLoaded } = useLoadScript({
    // replace with env var / safer approach for real apps
    googleMapsApiKey: GOOGLE_MAP_KEY,
  });
  const userData = JSON.parse(sessionStorage.getItem("userData") || "{}");
  const userId = userData?.user_id;
  const [user, setUser] = useState({});
  const [shipmentData, setShipmentData] = useState({});
  const [loading, setLoading] = useState(false);
  const [categoryName, setCategoryName] = useState("");
  const [categoryDescription, setCategoryDescription] = useState("");
  const [available24Hours, setAvailable24Hours] = useState(false);
  const [mapRef1, setMapRef1] = useState(null);

  useEffect(() => {
    // Retrieve saved values from sessionStorage
    const savedCategoryName = sessionStorage.getItem("categoryName");
    const savedCategoryDescription = sessionStorage.getItem("categoryDescription");

    if (savedCategoryName) setCategoryName(savedCategoryName);
    if (savedCategoryDescription) setCategoryDescription(savedCategoryDescription);

  }, []);
  useEffect(() => {
    // Ensure shipmentId is available (from QuoteDetails or persisted)
    if (!shipmentId) {
      const sid = sessionStorage.getItem("shipment_id");
      if (sid) {
        dispatch(setShipmentId(sid));
      }
    }
    const fetchUser = async () => {
      if (!userId) return;
      try {
        const res = await APIs.post(
          "user/getUserById",
          { user_id: userId },
          { headers: { "Content-Type": "application/json" } }
        );
        setUser(res.data?.data || {});
      } catch (err) {
        console.error("Error fetching user:", err);
      }
    };
    fetchUser();
  }, [userId]);

  const formatAddress = (addr) =>
    addr ? `${addr.address || ""}, ${addr.city || ""}, ${addr.state || ""}, ${addr.zip_code || ""}` : "Address not set";

  const validateForm = () => {
    const newErrors = {};
    if (!userId) newErrors.userId = "User ID missing";
    if (!pickupAddress?.address_id) newErrors.pickupAddress = "Pickup address missing";
    if (!dropoffAddress?.address_id) newErrors.dropoffAddress = "Drop-off address missing";
    if (!pickupDate) newErrors.pickupDate = "Pickup date missing";
    if (!available24Hours) {
      if (!pickupTime) newErrors.pickupTime = "Please select from time";
      if (!toTime) newErrors.toTime = "Please select to time";
      if (pickupTime === "Other" && !customTime) {
        newErrors.customTime = "Enter custom pickup time";
      }
    }
    if (!urgencyLevel) newErrors.urgencyLevel = "Please select urgency level";
    // if (!po_number) {
    //   newErrors.po_number = "Please enter PO Number";
    // }

    setErrors(newErrors);
    setLoading(false)
    return Object.keys(newErrors).length === 0;
  };
  console.log("Booking data:", items);

  const handleBooking = async () => {
    setLoading(true);
    if (loading) return;
    if (!validateForm()) return;
    console.log("Booking data11:");

    const formData = new FormData();
    formData.append("user_id", userId);
    formData.append("category_id", categoryId);
    formData.append("pickup_address_id", pickupAddress?.address_id || "");
    formData.append("drop_address_id", dropoffAddress?.address_id || "");
    formData.append("pickup_date", pickupDate);
    formData.append("pickup_time", available24Hours ? `${pickupTime} to ${toTime}` : pickupTime === "Other" ? customTime : `${pickupTime} to ${toTime}`);
    formData.append("urgency_level", urgencyLevel);
    formData.append("po_number", po_number || "");

    // 🔁 Loop through all items
    items.forEach((item, idx) => {
      formData.append(`items[${idx}][item_box_type]`, item.box.box_type || "Default");
      formData.append(`items[${idx}][item_name]`, item.itemTitle || "");
      formData.append(`items[${idx}][item_description]`, item.description || item.item_description || "");
      formData.append(`items[${idx}][item_width]`, parseFloat(item.itemWidth || item.item_width || 0));
      formData.append(`items[${idx}][item_height]`, parseFloat(item.itemHeight || item.item_height || 0));
      formData.append(`items[${idx}][item_length]`, parseFloat(item.itemLength || item.item_length || 0));

      // Handle weight
      const weight = parseFloat(item.itemWeight?.replace(/[^\d.]/g, "") || item.item_weight || 0);
      formData.append(`items[${idx}][item_weight]`, isNaN(weight) ? 0 : weight);

      formData.append(`items[${idx}][item_qty]`, item.quantity || 0);

      // 🖼️ Handle image: prefer item.file
      // if (item.file) {
      //   formData.append(`items[${idx}][image_field]`, item.file);
      // }
      if (item.file instanceof File) {
        // if user uploaded a file
        formData.append(`items[${idx}][image_field]`, item.file);
      } else if (item.item_image) {
        // if existing image from DB or API
        formData.append(`items[${idx}][image_field]`, item.item_image);
      } else {
        // if no image at all
        formData.append(`items[${idx}][image_field]`, "");
      }
    });

    // 🔍 Debug: print all FormData entries
    console.log("---- FormData Preview ----");
    for (let [key, value] of formData.entries()) {
      if (value instanceof File) {
        console.log(`${key} ->`, {
          name: value.name,
          size: value.size,
          type: value.type,
          lastModified: value.lastModified,
        });
      } else {
        console.log(`${key} ->`, value);
      }
    }

    try {
      let response;
      let newShipmentId = shipmentId;

      if (shipmentId) {
        console.log("Editing existing shipment with ID:", shipmentId);
        formData.append("shipment_id", shipmentId);
        response = await APIs.post("booking/editShipment", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
      } else {
        console.log("Creating new shipment with data:", formData);
        response = await APIs.post("booking/addShipment", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        newShipmentId = response?.data?.data?.shipment_id;
        if (newShipmentId) {
          dispatch(setShipmentId(newShipmentId));
          sessionStorage.setItem("shipment_id", newShipmentId);
        }
      }

      navigate(`/Step5/${newShipmentId}`);
    } catch (err) {
      console.error("Booking error:", err.response?.data || err.message);
    }
    finally {
      setLoading(false); // stop loader
    }
  };




  useEffect(() => {
    const fetchShipment = async () => {
      if (!shipmentId) return;

      try {
        const res = await APIs.post("booking/getShipmentById", { shipment_id: shipmentId });
        const data = res.data?.data;
        if (data) {
          setShipmentData(data);

          // Populate redux or local state for Step4
          if (data.pickup_address) {
            dispatch({ type: "address/setPickupAddress", payload: data.pickup_address });
          }
          if (data.drop_address) {
            dispatch({ type: "address/setDropoffAddress", payload: data.drop_address });
          }
          const pickupDateStr = (() => {
            const d = data.pickup_date;
            if (!d) return "";
            try {
              const dt = new Date(d);
              if (isNaN(dt)) return String(d).slice(0, 10);
              return dt.toISOString().split("T")[0];
            } catch {
              return String(d).slice(0, 10);
            }
          })();
          dispatch(setPickupDate(pickupDateStr));
          dispatch(setPickupTime(data.pickup_time));
          if (data.pickup_time_custom) dispatch(setCustomTime(data.pickup_time_custom));
          dispatch(setUrgencyLevel(data.urgency_level));
          const poNum = (data && (data.po_number ?? data.shipment?.po_number));
          if (poNum !== undefined && poNum !== null && String(poNum).trim() !== "") {
            dispatch(setpo_number(poNum));
          }

          // Items
          // You can also populate items in redux if needed
          // dispatch(setItems(data.items));
        }
      } catch (err) {
        console.error("Failed to fetch shipment for edit:", err);
      }
    };

    fetchShipment();
  }, [shipmentId]);

  const handleContinue = async (e) => {
    e.preventDefault();
    await handleBooking();
  };

  const pickupLat = pickupAddress?.address_lat ? parseFloat(pickupAddress.address_lat) : null;
  const pickupLng = pickupAddress?.address_long ? parseFloat(pickupAddress.address_long) : null;
  const dropLat = dropoffAddress?.address_lat ? parseFloat(dropoffAddress.address_lat) : null;
  const dropLng = dropoffAddress?.address_long ? parseFloat(dropoffAddress.address_long) : null;

  const centerLat = pickupLat && dropLat ? (pickupLat + dropLat) / 2 : pickupLat || dropLat || 0;
  const centerLng = pickupLng && dropLng ? (pickupLng + dropLng) / 2 : pickupLng || dropLng || 0;

  const path =
    pickupLat && pickupLng && dropLat && dropLng
      ? [
        { lat: pickupLat, lng: pickupLng },
        { lat: dropLat, lng: dropLng },
      ]
      : [];


      useEffect(() => {
        if (available24Hours && pickupTime) {
          // Convert "HH:MM" to hours + minutes
          const [hours, minutes] = pickupTime.split(":").map(Number);
      
          // Add 24 hours (wraps automatically next day)
          const newHours = (hours + 24) % 24;
      
          // Format back to "HH:MM"
          const formattedTime = String(newHours).padStart(2, "0") + ":" + String(minutes).padStart(2, "0");
      
          dispatch(setToTime(formattedTime));
        } else if (!available24Hours) {
          dispatch(setToTime(""));
        }
      }, [available24Hours, pickupTime]);
      
        useEffect(() => {
          if (mapRef1 && pickupLat && dropLat) {
            const bounds = new window.google.maps.LatLngBounds();
            bounds.extend({ lat: pickupLat, lng: pickupLng });
            bounds.extend({ lat: dropLat, lng: dropLng });
        
            mapRef1.fitBounds(bounds, {
              top: 50,
              bottom: 50,
              left: 50,
              right: 50
            });
          }
        }, [mapRef1, pickupLat, pickupLng, dropLat, dropLng]);

  console.log("Pickup", pickupTime)
  console.log("toTime", toTime)
  return (
    <div className="page-wrapper about-us">
      <div className="page-content">
        <section className="step-section-md">
          <div className="container">
            <div className="row">
              {/* LEFT COLUMN */}
              <div className="col-lg-6">
                <div className="shipment-information-new">
                  <div className="step-header">
                    <Link to="/">
                      <img src="/images/logo1.jpg" alt="Logo" className="img-fluid" />
                    </Link>
                    {user && Object.keys(user).length > 0 ? (
                      <div className="align-items-center d-flex gap-1">
                        <img
                          src={user.profile_image || "/images/user.png"}
                          alt="Profile"
                          style={{
                            width: "32px",
                            height: "32px",
                            borderRadius: "50%",
                            objectFit: "cover",
                            marginLeft: "25px",
                          }}
                        /><br></br>
                        <span>{user.full_name || ""}</span>
                      </div>
                    ) : (
                      <a data-bs-toggle="modal" href="#LoginModalToggle">
                        <i class="eagle-base-icon-user"></i> Sign In</a>
                    )}
                  </div>

                  <div className="new-title">
                    <h3>{categoryName || "Important Documents"}</h3>
                    <p>
                      {categoryDescription ||
                        "Rely on us for the swift and secure transport of sensitive, time-critical documents, ensuring confidentiality and timely arrival every time."}
                    </p>
                  </div>

                  <div
                    className="map-responsive"
                    style={{ borderRadius: 15, overflow: "hidden", border: "1px solid #c5c1c1", marginTop: 15 }}
                  >
                    {isLoaded ? (
                      <GoogleMap
                        mapContainerStyle={mapContainerStyle}
                        zoom={pickupLat && dropLat ? undefined : 8}
                        center={{ lat: centerLat, lng: centerLng }}
                        onLoad={(map) => setMapRef1(map)}
                      >
                        {pickupLat && pickupLng && (
                          <Marker
                            key="pickup"
                            position={{ lat: pickupLat, lng: pickupLng }}
                            // label={{ text: "P", color: "white", fontSize: "14px", fontWeight: "bold" }}
                            // fallback icon if window.google isn't ready is avoided since isLoaded is true
                            icon={{
                              url: "/images/srcmap.png", // or full URL
                              scaledSize: new window.google.maps.Size(30, 40), // resize image
                              anchor: new window.google.maps.Point(20, 40), // bottom center
                            }}
                          />
                        )}
                        {dropLat && dropLng && (
                          <Marker
                            key="dropoff"
                            position={{ lat: dropLat, lng: dropLng }}
                            // label={{ text: "D", color: "white", fontSize: "14px", fontWeight: "bold" }}
                            icon={{
                              url: "/images/destmap.png", // or full URL
                              scaledSize: new window.google.maps.Size(30, 40), // resize image
                              anchor: new window.google.maps.Point(20, 40), // bottom center
                            }}
                          />
                        )}
                        {path.length === 2 && (
                          <Polyline
                            path={path}
                            options={{
                              strokeColor: "#007bff",
                              strokeOpacity: 0.8,
                              strokeWeight: 3,
                            }}
                          />
                        )}
                      </GoogleMap>
                    ) : (
                      <div style={{ padding: 20, textAlign: "center" }}>Loading map...</div>
                    )}
                  </div>

                  {/* Pickup & Drop-Off */}
                  <div className="form-to-location mb-3">
                    <div className="form-location">
                      <div className="icon-ftl">
                        <i className="ti-arrow-up"></i>
                      </div>
                      <div className="flex-1">
                        <label>Pickup</label>
                        <h3>{pickupAddress?.name || pickupAddress?.address_type || "Home"}</h3>
                        <span>
                          {pickupAddress ? formatAddress(pickupAddress) : "Pickup Address"}
                        </span>
                      </div>
                      <Link to="/address?type=pickup" className="edite-icon">
                        <i className="ti-pencil"></i>
                      </Link>
                    </div>

                    <div className="to-location">
                      <div className="icon-ftl">
                        <i className="ti-arrow-down"></i>
                      </div>
                      <div className="flex-1">
                        <label>Drop-Off</label>
                        <h3>{dropoffAddress?.name || dropoffAddress?.address_type || "Office"}</h3>
                        <span>
                          {dropoffAddress ? formatAddress(dropoffAddress) : "Drop-Off Address"}
                        </span>
                      </div>
                      <Link to="/address?type=dropoff" className="edite-icon">
                        <i className="ti-pencil"></i>
                      </Link>
                    </div>
                  </div>

                  {/* Transported Items */}
                  <div className="vehicle-detail-new">
                    <div className="icon-ftl">
                      <i className="ti-archive"></i>
                    </div>
                    <div className="flex-1 overflow-hidden">
                      <label className="mb-1">What Are You Transporting?</label>
                      <div className="row">
                        {items.map((it, idx) => (
                          <div className="col-md-6 mb-3" key={idx}>
                            <div className="shipment-item-container">
                              <div className="shipment-item-img">
                                <img
                                  src={it.preview || "/images/defaultImage.jpg"}
                                  className="img-fluid"
                                  alt={it.itemTitle || "Item"}
                                  style={{ height: "100%", objectFit: "cover" }}
                                />
                              </div>
                              <div className="shipment-item-details">
                                <h5>
                                  {it.box?.box_type}
                                </h5>
                                <p className="small mb-1">{it.description}</p>
                                <p className="small mb-1">
                                  Size: {it.itemHeight} cm × {it.itemWidth} cm × {it.itemLength} cm
                                </p>
                                <p className="small mb-1">
                                  Box Weight: {it.itemWeight} kg
                                </p>
                                <p className="small mb-1">
                                  Quantity:{it.quantity}
                                </p>
                                <p className="small mb-1">
                                  Total Weight: {(it?.quantity * it?.itemWeight || 0)} kg
                                </p>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                    <Link to="/Step3" className="edite-icon">
                      <i className="ti-pencil"></i>
                    </Link>
                  </div>
                </div>
              </div>

              {/* RIGHT COLUMN */}
              <div className="col-lg-6">
                <div className="shipment-details-new">
                  <h3 className="step-count">STEP 4/5</h3>
                  <div className="progress-container">
                    {[1, 2, 3, 4, 5].map((step) => (
                      <div key={step} className={`new-progress ${step <= 4 ? "active" : ""}`} />
                    ))}
                  </div>

                  <div className="new-title">
                    <h3>Pickup Time</h3>
                  </div>

                  <form onSubmit={handleContinue}>
                    <div className="form-group">
                      <h5>PO Number</h5>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter PO Number"
                        value={po_number || ""} // ONLY Redux value
                        onChange={(e) => dispatch(setpo_number(e.target.value))}
                      />


                      {errors.po_number && <span className="text-danger">{errors.po_number}</span>}
                    </div>


                    <div className="form-group">
                      <h5>Select Day</h5>
                      <input
                        type="date"
                        className="form-control"
                        value={pickupDate || ""}
                        min={new Date().toISOString().split("T")[0]}
                        onChange={(e) => dispatch(setPickupDate(e.target.value))}
                      />

                      {errors.pickupDate && <span className="text-danger">{errors.pickupDate}</span>}
                    </div>

                    <div className="form-check mt-2">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="available24Hours"
                        checked={available24Hours}
                        onChange={(e) => setAvailable24Hours(e.target.checked)}
                        style={{ boxShadow: "none", outline: "none" }}
                      />
                      <label className="form-check-label border-0" htmlFor="available24Hours">
                        Available 24 hours
                      </label>
                    </div>

                    <div className="d-flex gap-3">
                      <div className="form-group flex-fill">
                        <h5>From Time</h5>
                        {/* <select
                        className="form-control form-select"
                        value={pickupTime || ""}
                        onChange={(e) => dispatch(setPickupTime(e.target.value))}
                      >
                        <option value="">Select time</option>
                        {[
                          "8am to 9am",
                          "9am to 10am",
                          "10am to 11am",
                          "11am to 12pm",
                          "12pm to 1pm",
                          "1pm to 2pm",
                          "2pm to 3pm",
                          "3pm to 4pm",
                          "4pm to 5pm",
                          "5pm to 6pm",
                          "6pm to 7pm",
                          "7pm to 8pm",
                          "8pm to 9pm",
                          "Other",
                        ].map((time) => (
                          <option key={time} value={time}>
                            {time}
                          </option>
                        ))}
                      </select> */}
                        <input
                          type="time"
                          className="form-control"
                          value={pickupTime || ""}
                          onChange={(e) => {
                            const timeValue = e.target.value; // e.g. "17:00"
                            dispatch(setPickupTime(timeValue)); // save "5pm"
                          }}
                        />
                        {errors.pickupTime && <span className="text-danger">{errors.pickupTime}</span>}

                        {pickupTime === "Other" && (
                          <input
                            type="text"
                            className="form-control mt-2"
                            placeholder="Enter custom time"
                            value={customTime || ""}
                            onChange={(e) => dispatch(setCustomTime(e.target.value))}
                          />
                        )}

                        {errors.customTime && <span className="text-danger">{errors.customTime}</span>}
                      </div>
                      {!available24Hours ?

                        <div className="form-group flex-fill">
                          <h5>To Time</h5>
                          <input
                            type="time"
                            className="form-control"
                            value={toTime || ""}
                            disabled={available24Hours}
                            onChange={(e) => {
                              const timeValue = e.target.value; // e.g. "17:00"

                              if (pickupTime && timeValue < pickupTime) {
                                toast.error("To time cannot be before from time");
                                dispatch(setToTime("")); // optional: clear invalid value
                                return;
                              }
                              dispatch(setToTime(timeValue)); // save "5pm"
                            }}
                          />
                          {errors.toTime && <span className="text-danger">{errors.toTime}</span>}

                        </div>
                        : null}

                    </div>

                    <div className="form-group mb-2">
                      <h5>Urgency Level</h5>
                      <div className="row">
                        {["Emergency", "High", "Low"].map((level) => (
                          <div key={level} className="col-12 col-md-6 col-lg-4">
                            <input
                              type="radio"
                              className="btn-check"
                              name="urgency-level"
                              id={level}
                              autoComplete="off"
                              checked={urgencyLevel === level}
                              onChange={() => dispatch(setUrgencyLevel(level))}
                            />
                            <label className="btn btn-secondary w-100" htmlFor={level}>
                              {level === "Emergency"
                                ? "Critical / Emergency"
                                : level === "High"
                                  ? "High Priority"
                                  : "Low Priority"}
                            </label>
                          </div>
                        ))}

                      </div>
                      {errors.urgencyLevel && <span className="text-danger">{errors.urgencyLevel}</span>}
                    </div>

                    <div className="button-wraper-new d-flex gap-2">
                      <button
                        type="button"
                        className="btn btn-dark btn-lg"
                        onClick={() => navigate("/Step3")}
                        disabled={loading}
                      >
                        Back
                      </button>

                      <button
                        type="submit"
                        className="btn btn-success btn-lg flex-1"
                        disabled={loading}
                      >
                        {loading ? (
                          <>
                            <span
                              className="spinner-border spinner-border-sm me-2"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            Processing...
                          </>
                        ) : (
                          "Continue"
                        )}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Step4;
